module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-table/~/babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 1918
 ** module chunks = 3
 **/